module.exports = __webpack_public_path__ + "static/media/Wework.54566fa0.svg";